module.exports = __webpack_public_path__ + "img/button-right.a0774a0.png";